import React from 'react'
import { Box, Button, ChakraProvider, Stack, Text } from '@chakra-ui/react'
import Logo from '~editor/components/Logo'
import { useRouter } from 'next/router'
import theme from '~editor/theme'
import { usePenpal } from '~core/hooks/usePenpal'

const PageNotFound404 = () => {
  const router = useRouter()
  const { goToForge } = usePenpal()
  const canGoBack = typeof window !== 'undefined' && history?.state?.idx > 0

  return (
    <ChakraProvider resetCSS theme={theme}>
      <Box
        height="100vh"
        width="100vw"
        maxWidth="100vw"
        background="linear-gradient(180deg, #1D1F29 0%, #0D0E12 100%);"
        backgroundSize="cover"
        backgroundPosition="center center"
        backgroundRepeat="no-repeat"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box textAlign="center">
          <Logo />
          <Text
            margin="40px auto"
            // color="#9BA3B0"
            color="#FFF"
            fontFamily="Proxima Nova"
            fontSize="50px"
            lineHeight="1.1"
            fontWeight="bold"
          >
            {'Not Found'}
          </Text>

          <Stack
            flexDirection="row"
            spacing={4}
            alignItems="center"
            justifyContent="center"
          >
            <Button
              onClick={() => goToForge()}
              variant={'primary'}
              fontWeight={700}
              className="saveButton" // Needed for onboarding
              width="125px"
              size="md"
            >
              {'Shard selection'}
            </Button>

            {canGoBack && (
              <Button
                onClick={() => router.back()}
                variant={'outline'}
                fontWeight={700}
                className="saveButton" // Needed for onboarding
                width="125px"
                size="md"
              >
                {'Go back'}
              </Button>
            )}
          </Stack>
        </Box>
      </Box>
    </ChakraProvider>
  )
}

export default PageNotFound404
